// @core/api/endpoints/form/list_form_policies.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListFormPoliciesResponse,
} from '../../../types/form';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/form';

/**
 * List form policies
 * Returns form policies, optionally filtered by scope entity type.
 */
export async function ListFormPolicies(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListFormPoliciesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/form-policies`;
  const requestOptions = options;
  return client.get<ListFormPoliciesResponse>(requestPath, { ...requestOptions, params });
}
